module.exports = __webpack_public_path__ + "static/media/sample_lmtransporters.aabbc3b6.csv";